import { useState, useEffect, useCallback } from "react";
import api from "@/lib/api";

const money = (v) => `$${Number(v || 0).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;

export const QuoteSummary = ({ planId, invoice: given, monthly }) => {
  const [inv, setInv] = useState(given || null);
  const load = useCallback(() => { if (!given) api.get(`/api/webadvisor/plan/${planId}`).then(r => setInv(r.data.invoice)).catch(() => {}); }, [planId, given]);
  useEffect(() => { load(); window.addEventListener("wa-quote-changed", load); return () => window.removeEventListener("wa-quote-changed", load); }, [load]);
  useEffect(() => { if (given) setInv(given); }, [given]);
  if (!inv) return null;
  if (!inv.items?.length && !monthly) return null;
  return (
    <div className="bg-slate-900 text-white rounded-2xl p-6 shadow-xl" data-testid="quote-summary">
      <h3 className="text-lg font-bold mb-3">Proposal Summary</h3>
      <div className="space-y-1.5 text-sm">
        {(inv?.items || []).map((i, k) => (
          <div key={k} className="flex justify-between gap-4"><span className="text-slate-300">{i.label}{i.qty > 1 ? ` (${i.qty} × ${money(i.unit_price)})` : ""}</span><span className="font-semibold">{money(i.amount)}</span></div>
        ))}
      </div>
      <div className="grid grid-cols-2 gap-4 mt-4 pt-4 border-t border-white/10">
        <div><p className="text-xs uppercase tracking-wider text-slate-400">Total investment</p><p className="text-3xl font-black" data-testid="quote-summary-total">{money(inv?.total)}</p></div>
        {monthly > 0 && <div><p className="text-xs uppercase tracking-wider text-slate-400">Monthly Mgmt</p><p className="text-3xl font-black">{money(monthly)}</p></div>}
      </div>
    </div>
  );
};
